import React from "react";
import "./style.scss";

interface IProps {
  label: string;
  value: boolean;
  setValue: (value: boolean) => void;
}

const CheckboxCustom: React.FC<IProps> = ({ label, value, setValue }: IProps) => {
  return (
    <label className={"container-checkbox"}                   
    >
      <span dangerouslySetInnerHTML={{ __html: label }}></span>
      <input type="checkbox" checked={value} onChange={() => setValue(!value)} />
      <span className="checkmark"></span>
    </label>
  );
};

export default CheckboxCustom;
